import { sayHello } from './modules/myotherfile.js';
import Header from './modules/header.js';
import Menu from './modules/menu.js';

document.addEventListener('DOMContentLoaded', () => {
  new Header(); 
  new Menu(); 

});


    